import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const ResetSenhas = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'NetalimaGest - Gestão de Passageiros';
  }, []);

  const handleReset = async () => {
    if (!window.confirm('Tem certeza que deseja resetar as senhas dos usuários padrão?')) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/api/reset-senhas');
      toast.success('Senhas resetadas com sucesso!');
      console.log('Usuários:', response.data.usuarios);
      alert(`
Senhas resetadas com sucesso!

Credenciais:
- Admin: admin@netalima.com / admin123
- Financeiro: financeiro@netalima.com / financeiro123
- Atendente: atendente@netalima.com / atendente123
      `);
    } catch (error) {
      toast.error('Erro ao resetar senhas: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-600 mb-2">Resetar Senhas</h1>
          <p className="text-gray-600">Resetar senhas dos usuários padrão</p>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-yellow-800">
            <strong>Atenção:</strong> Esta ação irá resetar as senhas dos usuários padrão para os valores iniciais.
          </p>
        </div>

        <button
          onClick={handleReset}
          disabled={loading}
          className="w-full bg-primary-600 text-white py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Resetando...' : 'Resetar Senhas'}
        </button>

        <div className="mt-6 text-sm text-gray-600">
          <p className="font-semibold mb-2">Credenciais padrão após reset:</p>
          <ul className="space-y-1">
            <li>Admin: admin@netalima.com / admin123</li>
            <li>Financeiro: financeiro@netalima.com / financeiro123</li>
            <li>Atendente: atendente@netalima.com / atendente123</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ResetSenhas;
